import {NgModule} from '@angular/core';
import {Route, RouterModule} from '@angular/router';
import {PortfoliosComponent} from './portfolios/portfolios.component';
import {AssignedAccountsComponent} from '@irb/irb-clients/assigned-accounts/assigned-accounts.component';
import {UnassignedComponent} from '@irb/irb-clients/unassigned/unassigned.component';
import {AgGridModule} from 'ag-grid-angular';
import {IrbCommonModule} from '@irb-common/irb-common.module';
import {CustomEditorComponent} from '@irb/irb-clients/portfolios/custom-editor/custom-editor.component';
import {CustomfilterComponent} from '@irb/irb-clients/portfolios/customfilter/customfilter.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {DialogModule} from 'primeng/dialog';
import {ImportCashSettingsDialogComponent} from './import-cash-settings-dialog/import-cash-settings-dialog.component';
import {ImportAccountsToPortfolioComponent} from './import-accounts-to-portfolio/import-accounts-to-portfolio.component';
import {ImportCashSettingsResultDialogComponent} from './import-cash-settings-result-dialog/import-cash-settings-result-dialog.component';
import {ImportAccountsToPortfolioResultDialogComponent} from './import-accounts-to-portfolio-result-dialog/import-accounts-to-portfolio-result-dialog.component';
import {AssignAccountsToPortfolioDialogComponent} from './assign-accounts-to-portfolio-dialog/assign-accounts-to-portfolio-dialog.component';
import {DeletePortfolioDialogComponent} from './delete-portfolio-dialog/delete-portfolio-dialog.component';
import {ImportExternalAccountsDialogComponent} from './import-external-accounts-dialog/import-external-accounts-dialog.component';
import {ImportExternalAccountsResultDialogComponent} from './import-external-accounts-result-dialog/import-external-accounts-result-dialog.component';
import {EditMultiplePortfoliosDialogComponent} from './edit-multiple-portfolios-dialog/edit-multiple-portfolios-dialog.component';
import {ImportExternalAccountsSecuritiesDialogComponent} from './import-external-accounts-securities-dialog/import-external-accounts-securities-dialog.component';
import {ImportExternalAccountsReadyDialogComponent} from './import-external-accounts-ready-dialog/import-external-accounts-ready-dialog.component';
import {DeleteExternalAccountsDialogComponent} from "@irb/irb-clients/delete-external-accounts-dialog/delete-external-accounts-dialog.component";
import {GlobalCashCellRendererComponent} from "@irb/irb-clients/assigned-accounts/global-cash-cell.renderer.component";
import {irbNavigationGuard} from '@irb-common/modules/main-menu/main-menu.navigation.guard';
import {irbRouteAuthorizationAccessGuard} from "@irb-common/modules/main-menu/route-authorization-access.guard";
import { CreateExternalAccountsDialogComponent } from './create-external-accounts-dialog/create-external-accounts-dialog.component';
import { CreateExternalAccountsCompleteDialogComponent } from './create-external-accounts-complete-dialog/create-external-accounts-complete-dialog.component';
import { ImportPortfolioNamesDialogComponent } from './import-portfolio-names-dialog/import-portfolio-names-dialog.component';
import { ImportPortfolioNamesResultDialogComponent } from './import-portfolio-names-result-dialog/import-portfolio-names-result-dialog.component';
import { ImportModelCategoryDialogComponent } from './import-model-category-dialog/import-model-category-dialog.component';
import { ImportModelCategoryResultDialogComponent } from './import-model-category-result-dialog/import-model-category-result-dialog.component';
import {
  EditMultiplePortfoliosAutomationDialogComponent
} from "@irb/irb-clients/edit-multiple-portfolios-automation-dialog/edit-multiple-portfolios-automation-dialog.component";

const ROUTES: Route[] = [
  {path: 'unassigned-accounts', component: UnassignedComponent, canDeactivate: [irbNavigationGuard], canActivate:[irbRouteAuthorizationAccessGuard]},
  {path: 'accounts', component: AssignedAccountsComponent, canDeactivate: [irbNavigationGuard], canActivate:[irbRouteAuthorizationAccessGuard]},
  {path: 'portfolios', component: PortfoliosComponent, canDeactivate: [irbNavigationGuard], canActivate:[irbRouteAuthorizationAccessGuard]}
];

@NgModule({
  imports: [
    RouterModule.forChild(ROUTES),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IrbCommonModule,
    TableModule,
    DialogModule,
    AgGridModule
  ],
  declarations: [
    PortfoliosComponent,
    CustomEditorComponent,
    CustomfilterComponent,
    AssignedAccountsComponent,
    UnassignedComponent,
    ImportCashSettingsDialogComponent,
    ImportAccountsToPortfolioComponent,
    ImportCashSettingsResultDialogComponent,
    ImportAccountsToPortfolioResultDialogComponent,
    AssignAccountsToPortfolioDialogComponent,
    DeletePortfolioDialogComponent,
    DeleteExternalAccountsDialogComponent,
    EditMultiplePortfoliosDialogComponent,
    EditMultiplePortfoliosAutomationDialogComponent,
    ImportExternalAccountsDialogComponent,
    ImportExternalAccountsResultDialogComponent,
    ImportExternalAccountsSecuritiesDialogComponent,
    ImportExternalAccountsReadyDialogComponent,
    CreateExternalAccountsDialogComponent,
    CreateExternalAccountsCompleteDialogComponent,
    GlobalCashCellRendererComponent,
    ImportPortfolioNamesDialogComponent,
    ImportPortfolioNamesResultDialogComponent,
    ImportModelCategoryDialogComponent,
    ImportModelCategoryResultDialogComponent
  ],
  exports: [
    CustomEditorComponent,
    CustomfilterComponent,
    GlobalCashCellRendererComponent
  ]
})
export class IrbClientsModule {
}
